module.exports = __webpack_public_path__ + "static/media/WENDY.6a7aee06.jpg";